<template>
    <div class="mb-20 mb-md-30">
        <v-row align="center" justify="space-between" class="row--x-small">
            <v-col cols="12" md="auto"> </v-col>
            <v-col cols="12" md="auto">
                <v-text-field v-model="searchValue" @keydown.enter="search" outlined hide-details append-icon="mdi-magnify" @click:append="search">
                    <template #prepend>
                        <v-select v-model="searchKey" :items="searchKeys" outlined hide-details />
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="auto"> </v-col>
        </v-row>
    </div>
</template>

<script>
const searchKeys = [
    { text: "전체", value: null },
    { text: "이름", value: "name" },
    { text: "국가", value: "country" },
];
export default {
    props: {
        summary: { type: Object, default: () => ({ totalCount: 0 }) },
    },
    data() {
        return {
            searchKeys,
            searchKey: this.$route.query.searchKey || null,
            searchValue: this.$route.query.searchValue || null,
        };
    },
    watch: {
        "$route.query.searchKey"() {
            this.searchKey = this.$route.query.searchKey || null;
            this.searchValue = this.$route.query.searchValue || null;
        },
        "$route.query.searchValue"() {
            this.searchKey = this.$route.query.searchKey || null;
            this.searchValue = this.$route.query.searchValue || null;
        },
    },
    methods: {
        search() {
            const { searchKey, searchValue } = this;

            const query = { ...this.$route.query, searchKey, searchValue };

            delete query.page;
            if (!searchKey) delete query.searchKey;
            if (!searchValue) delete query.searchValue;

            this.$router.push({ query });
        },
    },
};
</script>
